const ACTION_TYPE_EDIT_COMPANY_USER_REQUEST = 'ACTION_TYPE_EDIT_COMPANY_USER_REQUEST';
const ACTION_TYPE_EDIT_COMPANY_USER_SUCCESS = 'ACTION_TYPE_EDIT_COMPANY_USER_SUCCESS';
const ACTION_TYPE_EDIT_COMPANY_USER_FAILURE = 'ACTION_TYPE_EDIT_COMPANY_USER_FAILURE';

export {
  ACTION_TYPE_EDIT_COMPANY_USER_REQUEST,
  ACTION_TYPE_EDIT_COMPANY_USER_SUCCESS,
  ACTION_TYPE_EDIT_COMPANY_USER_FAILURE,
};
